import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Login } from '@models/login.model';
import { Session } from '@models/sesion.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService extends HttpService {
  apiUrl = `${environment.apiUrl}/users/`;
  test = false;
  t: any;

  login(info: Login): Observable<any> {
    const url = `${this.apiUrl}login`;
    return this.post(url, info);
  }

  getSessionInfo(token): Observable<any> {
    const defaultOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
      })
    };
    return this.get(`${this.apiUrl}session`, defaultOptions);
  }

  isLoggedIn(): boolean {
    const session: Session = this.getCurrentSession();

    if (session !== null) {
      return true;
    }

    return false;
  }

  isAdmin(): boolean {
    const role = this.storageService.get('roleName').toLowerCase();
    return role === 'admin';
  }

  isSuperAdmin(): boolean {
    const role = this.storageService.get('roleName').toLowerCase();
    return role === 'superadmin';
  }

  private getCurrentSession(): Session {
    const session: Session = new Session();
    if (!this.test){
      this.t = new Date();
      this.t.setMinutes(this.t.getMinutes() + 10);
      this.test = true;
    }

    const tok = this.storageService.get('tok');

    if (tok !== null) {
      session.token = tok;
      return session;
    }else{
      return null;
    }
  }
}
